import type { LeadAddRequest as LeadAddRequestParams } from "@litres-libs/types";
import { rtkqApi } from "../api/rtkqApi";

export const externalReferralApi = rtkqApi.injectEndpoints({
  endpoints: build => ({
    addAdvCakeReferral: build.mutation<
      void,
      {
        track_id: string;
        track_url: string;
      }
    >({
      query({ track_id, track_url }) {
        return {
          url: "/foundation/api/users/external-referral",
          method: "PUT",
          body: {
            track_id,
            track_url,
          },
        };
      },
    }),
    createLead: build.mutation<void, LeadAddRequestParams>({
      query({ name, email, question }) {
        return {
          url: "/foundation/api/referrals/leads",
          method: "POST",
          body: {
            name,
            email,
            question,
          },
        };
      },
    }),
  }),
});
